import { render, staticRenderFns } from "./AuthContainer.vue?vue&type=template&id=2c2aea2e&scoped=true&"
import script from "./AuthContainer.vue?vue&type=script&lang=js&"
export * from "./AuthContainer.vue?vue&type=script&lang=js&"
import style0 from "./AuthContainer.vue?vue&type=style&index=0&id=2c2aea2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2aea2e",
  null
  
)

export default component.exports